module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC43NCAyOC43NCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwMWE7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xLDI3Ljc0LDI3Ljc0LDEiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yNy43NCwyNy43NCwxLDEiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-close-black.svg
// module id = 9VYc
// module chunks = 13